import { Utils } from '@genial/utils';

export const getDaysDifferenceFromTodayText = (date?: Date | null) => {
  if (!date) {
    return '';
  }
  const daysRemaining = Utils.Date.DaysDifferenceFromToday(date);
  if (daysRemaining > 1) {
    return `${daysRemaining} ${daysRemaining > 1 ? 'dias' : 'dia'}`;
  }
  return '';
};
